import "core-js/modules/es.function.name.js";
import { initializeApp, setLogLevel } from 'firebase/app';
import { getMessaging } from 'firebase/messaging';
export var initFirebase = function initFirebase() {
  // Configurações: https://console.firebase.google.com/u/0/project/melembre-1/settings/general
  try {
    var firebaseConfig = {
      apiKey: 'AIzaSyCCHIktePyn4ZKXkKF2zaZPRGBFjpVATRY',
      appId: '1:904809205401:web:0a4528ac0604949656f208',
      messagingSenderId: '904809205401',
      projectId: 'melembre-1'
    };
    setLogLevel('verbose');
    var app = initializeApp(firebaseConfig);
    console.debug("Firebase: ".concat(app.name));

    // Pega uma instância do Firebase Messaging para poder tratar mensagens em background
    var messaging = getMessaging(app);
    if (messaging) {
      console.debug('Firebase Messaging habilitado.');
    }
  } catch (error) {
    console.error(error);
  }
};